import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { Badge } from '@/components/ui/badge';
import { Wifi, WifiOff } from 'lucide-react';

export function RealtimeStatus() {
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    let channel: any = null;
    
    try {
      channel = supabase.channel('status_check');
      
      channel
        .on('system', { event: 'disconnect' }, () => {
          setIsConnected(false);
        })
        .on('system', { event: 'connect' }, () => {
          setIsConnected(true);
        })
        .subscribe((status) => {
          console.log('RealtimeStatus subscription status:', status);
          setIsConnected(status === 'SUBSCRIBED');
        });
    } catch (error) {
      console.error('Error setting up realtime status channel:', error);
      setIsConnected(false);
    }

    return () => {
      if (channel) {
        try {
          supabase.removeChannel(channel);
        } catch (error) {
          console.error('Error removing realtime status channel:', error);
        }
      }
    };
  }, []);

  return (
    <div className="flex items-center gap-2">
      {isConnected ? (
        <>
          <Wifi className="h-4 w-4 text-green-500" />
          <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
            Live
          </Badge>
        </>
      ) : (
        <>
          <WifiOff className="h-4 w-4 text-red-500" />
          <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200">
            Offline
          </Badge>
        </>
      )}
    </div>
  );
} 